import { useMemo } from 'react';

import { getInsuranceProviderById } from '../../../enums/insurance-providers';
import { CostReviewLineItemWithRecommendation } from '../cost-review-line-item-with-recommendation/cost-review-line-item-with-recommendation';

/**
 * @param {object} props
 * @param {boolean} props.isRecommendationSelected
 * @param {(recommendationKey: string) => void} props.onToggleRecommendation
 * @param {CostReviewInsuranceRecommendation} props.insuranceRecommendation
 * @param {boolean} [props.isToggleRecommendationDisabled]
 * @param {number} props.originalInsuranceCostAmount
 * @param {string} props.originalInsuranceCostCurrencyCode
 * @param {string|React.ReactNode} props.originalInsuranceName
 * @returns {React.JSX.Element}
 */
export const CostReviewLabelProviderInsuranceLineItemWithRecommendation = ({
  isRecommendationSelected,
  onToggleRecommendation,
  insuranceRecommendation,
  isToggleRecommendationDisabled,
  originalInsuranceCostAmount,
  originalInsuranceCostCurrencyCode,
  originalInsuranceName,
}) => {
  const recommendation = useMemo(() => {
    const { name, insuranceProviderId } = getInsuranceProviderById(insuranceRecommendation.toInsuranceProviderId);

    return {
      key: insuranceRecommendation.key,
      totalSavings: insuranceRecommendation.totalSavings,
      name,
      insuranceProviderId,
    };
  }, [insuranceRecommendation.key, insuranceRecommendation.totalSavings, insuranceRecommendation.toInsuranceProviderId]);

  return (
    <CostReviewLineItemWithRecommendation
      isRecommendationSelected={isRecommendationSelected}
      isToggleRecommendationDisabled={isToggleRecommendationDisabled}
      onToggleRecommendation={onToggleRecommendation}
      originalServiceCost={originalInsuranceCostAmount}
      originalServiceCurrencyCode={originalInsuranceCostCurrencyCode}
      originalServiceName={originalInsuranceName}
      recommendation={recommendation}
    />
  );
};
